import styled from 'styled-components';

export const MobileTopbar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
`;

export const MobileButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;
